import { Injectable } from '@angular/core';
import { catchError, tap } from 'rxjs/operators';
import { Location, LocationResponse } from './models/location';
import { BaseService } from './shared/base.service';

@Injectable({
  providedIn: 'root'
})
export class LocationService extends BaseService {
  private locationsDataUrl = this.apiUrl + '/locations';

  addLocationData(location: Location) {
    return this.http.post<LocationResponse>(this.locationsDataUrl, location, this.httpOptions).pipe(
      tap((newLocationData: LocationResponse) => this.log(`added location: ${newLocationData}`)),
      catchError(this.handleError<LocationResponse>('addLocationData', <LocationResponse>{}))
    );
  }

  updateLocationData(location: Location) {
    const url = `${this.locationsDataUrl}/${location.id}`;

    return this.http.put<LocationResponse>(url, location, this.httpOptions).pipe(
      tap((newLocationData: LocationResponse) => this.log(`location updated: ${newLocationData}`)),
      catchError(this.handleError<LocationResponse>('updateLocationData', <LocationResponse>{}))
    );
  }
}
